import type { SortOption, SortSelection } from "@src/features/clips/types/camera";

export type SortOptionItem = {
  label: string;
  value: SortOption;
};

export const CAMERA_SORT_OPTIONS: SortOptionItem[] = [
  { label: "ID", value: "id" },
  { label: "Nickname", value: "nickname" },
  { label: "Name", value: "name" },
  { label: "Site", value: "site" },
];

export function toggleSortOption(selection: SortSelection, option: SortOption): SortSelection {
  if (selection.includes(option)) {
    return selection.filter((value) => value !== option);
  }
  return [...selection, option];
}
